@for (file of dbFilesStateService.dbFilesState(); track $index) {
  <div class="file-library-card">
    <app-file-card
      class="app-file-card"
      [fileCard]="{
        id: file.id,
        fileParams: file.file,
        fileType: designBlockEntityFileType(),
        isEditModeActive: isEditModeActive(),
        shouldCheckImageType: true
      }"
      [imgSize]="{
        width: '100%',
        height: '250px'
      }"
      [isNeedPreview]="true"
      [cardVariant]="'second'"
      (handleDelete)="handleDelete($event, file)"
    />
  </div>
}
